<template src="./unitDetailVue.template.html"></template>
<script>
const testObj = {
  //Need to remove
  AccountCount: 2,
  GatewayCount: 0,
  Integration: "QuickBooks",
  IntegrationId: 9,
  IsIntegrated: true,
  StateId: 1,
  StatusName: null,
};
import * as axios from "axios";
import moment from "moment-timezone";
import draggable from "vuedraggable";
import foliomodal from "../../reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue";
export default {
  name: "unitDetailComponent",
  props: ["unitId"],
  components: {
    draggable,
    foliomodal,
  },
  data() {
    return {
      apiUrl:
        window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":1339" : ""),
      isBgColor1: true,
      isBgColor2: false,
      isBgColor3: false,
      isBgColor4: false,
      isBgColor5: false,
      isBgColor6: false,
      isBgColor7: false,
      isBgColor8: false,
      isBgColor9: false,
      isBgColor10: false,
      isBgColor11: false,
      Unit_Status: {},
      statusList: [],
      unitClass: [],
      UnitClass: [],
      propertyList: [],
      AminitiesData: [],
      checkedAminities: [],
      unitImages: [],
      selectedUnitClassObj: {},
      status: {},
      isDisabled: false,
      displaySectionValue: "UnitInfo1",
      unitData: {},
      IsRatesRestrictions: true,
      modalParams: {},
      isModalVisible: false,
      unitID: -1,
      imageData: [],
      imageArr: [],
      index: null,
      imgs: [],
      visible: false,
      selectedImageId: null,
      showConnectToStripe: false,
      accountList: [
        {
          name: "deekshitha",
          accountId: "acct_1ED8aUJ93Ik4El3q",
        },
        {
          name: "bob",
          accountId: "acct_1EAuCsIfgqbN94ww",
        },
      ],
      stripeUrl:
        "https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_EbEZy2NBGahJqCQvfb7rRcMI0rkmL6gQ&scope=read_write&state={client}",
      accountEdit: false,
      paymentAccountList: [],
      paymentAccountEdit: null,
      editDefault: true,
      commissionPercentColor: null,
      accountStatusList: [
        {
          statusName: "Active",
          statusId: 1,
        },
        {
          statusName: "Inactive",
          statusId: 0,
        },
        {
          statusName: "Obsolete",
          statusId: -1,
        },
        {
          statusName: "Remove Integration",
          statusId: -2,
        },
      ],
      IsActive: 1,
      CommissionAmount: null,
      commissionPercent: null,
      ruSyncMethodsList: [
        {
          method: "Inventory",
          IsChecked: true,
        },
        {
          method: "Rates",
          IsChecked: true,
        },
        {
          method: "Restrictions",
          IsChecked: true,
        },
      ],
      IsLive: null,
      unitTypeList: [],
      selectedUnitTypeObj: {},
      RatesRestrictions_UnitType: null,
      crsPropertyId: null,
      integrationChannels: {},
      previousUnitTypeObj: {},
      unitSets: [],
      // selectedUnitSetId: null,
      selectedComponents: [],
      filteredUnits: [],
      unitList: [],
      filterSearchUnitText: null,
      selectedFilterColumn: null,
      showUnitsList: false,
      updatesuite: 0,
      ruClientAccountList: [],
      propertyList: [],
      ruPropertyObj: {},
      crsUnitClass: [],
      crsAmenities: [],
      actualUnitClassList: [],
      actualCrsAmenities: [],
      section1val: false,
      section2val: false,
      section3val: false,
      section4val: false,
      section5val: false,
      section6val: false,
      section7val: false,
      unitConnectedRuAccount: [],
      crsOwnerId: "",
      selectedRuClientAccountList: {},
      wheelHouseUserList: [],
      selectedIntgratedIds: null,
      listOfIntegrations: [],
      integrationName: null,
      componentIntegrationId: null,
      selectedPaymentAccount: {},
      showIntegrationScreen: true,
      selectedIntegration: {},
      customFieldsList:[{}],
      showLovList:false,
      selectedLovDropdown:null
    };
  },

  methods: {
    showSidePanel(integrationId, integration) {
      let vm = this;
      vm.displaySection("syncToRU");
      vm.selectedIntegration = integration;
      vm.componentIntegrationId = integrationId;
    },
    activeClass(integrationName) {
      return this.integrationName === integrationName;
    },
    Get_ListOfIntegrations() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_ListOfIntegrations",
        params: {
          ModuleAction: "Get_ListOfIntegrations",
        },
        callback: function (err, response) {
          if (err) {
            return;
          } else {
            console.log("response in Get_ListOfIntegrations", response);
            vm.listOfIntegrations = response[0];
            // vm.listOfIntegrations.push(testObj)          //Need to remove,Temporary used
          }
        },
      });
    },
    wheelHouseUserListData(wheelhousedata) {
      let vm = this;
      vm.wheelHouseUserList.splice(
        0,
        vm.wheelHouseUserList.length,
        ...wheelhousedata
      );
      vm.selectedIntgratedIds = vm.wheelHouseUserList
        .filter((val) => val.IntegrationId === 5 || val.IntegrationId === 6)
        .map((item) => item.IntegrationId);
      console.log("selectedIntgratedIds----", vm.selectedIntgratedIds);
    },
    getPropertyMetaData() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetPropertiesBySearchText",
        params: {},
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("GetPropertiesBySearchText==>", response);
            vm.propertyList.splice(
              0,
              vm.propertyList.length,
              ...response.propertyList
            );
          }
        },
      });
    },
    getRentalUnitedClients(unitId) {
      var vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_ListOfIntegrations_RU",
        params: {
          PropertyId: null,
          UnitId: unitId ? unitId : vm.unitData.UnitId,
        },
        callback: function (err, response) {
          if (err) {
            console.log("Error in Get_ListOfIntegrations_RU => ", err);
            return;
          }
          if (response) {
            console.log("response in Get_ListOfIntegrations_RU", response);
            vm.ruClientAccountList.splice(
              0,
              vm.ruClientAccountList.length,
              ...response[0]
            );
            console.log("vm.ruClientAccountList", vm.ruClientAccountList);
            vm.unitConnectedRuAccount = vm.ruClientAccountList.filter(
              (ruaccount) =>
                ruaccount.CrsStatus == 3 && ruaccount.IntegrationId == 1
            );
            console.log("vm.unitConnectedRuAccount", vm.unitConnectedRuAccount);
          }
        },
      });
    },
    showPopUp() {
      let vm = this;

      // if (vm.unitData.RatesRestrictions_UnitType == 1 || vm.unitData.RatesRestrictions_UnitType == true) {
      //   vm.UpdateRatesandRestriction_unit_unittype(1)
      // }
      // else if (vm.unitData.RatesRestrictions_UnitType == 0 || vm.unitData.RatesRestrictions_UnitType == false) {
      //   vm.UpdateRatesandRestriction_unit_unittype(0)
      // }
      // if (vm.unitData.RatesRestrictions_UnitType == 0 || vm.unitData.RatesRestrictions_UnitType == false) {
      if (vm.unitData.IsHostMode != 1) {
        vm.isModalVisible = true;
        vm.modalParams = {
          popupTitle: "Update Unit Type Rates?",
          // popupMessage: "All units within a single Unit Type must share the same Rates and Restrictions.By changing this setting, the system will use the Rates and Restrictions associated with Unit" + " " + vm.unitData.UnitName + " " + "to update all units associated with" + " " + vm.selectedUnitTypeObj.UnitTypeName + "(" + vm.selectedUnitTypeObj.propertyNickName + ")" + " " + "Unit Type.",
          popupMessage:
            "All units within a single Unit Type must share the same rates and restrictions.  Which information should we use when there are differences?",
          UnitId:
            vm.$route.params.unitId == -99 ||
            vm.$route.params.unitId == -1 ||
            vm.$route.params.unitId == undefined
              ? true
              : false,
          yesButtontext: "Use Unit Rates",
          noButtonText: "Use Unit Type Rates",
          yesButtonCallback: vm.changeToggel,
          noButtonCallback: vm.dontchangeToggel,
          from: "Unit",
        };
      }
      // }
      // else {
      //   vm.isModalVisible = false;
      // }
    },
    changeToggel() {
      let vm = this;
      vm.isModalVisible = false;
      vm.unitData.RatesRestrictions_UnitType = false;
    },
    dontchangeToggel() {
      let vm = this;
      vm.isModalVisible = false;
      vm.unitData.RatesRestrictions_UnitType = true;
    },
    closePopup() {
      let vm = this;
      vm.isModalVisible = false;
      vm.selectedUnitTypeObj = vm.previousUnitTypeObj;
    },

    updateStartSaleDate(key, dateObj, thisObj) {
      let vm = this;
      vm.unitData.StartSaleDate = dateObj
        ? dateObj.format("DD MMM YYYY")
        : null;
      console.log("vm.unitData.StartSaleDate", vm.unitData.StartSaleDate);
      // vm.getHouseKeepinglist();
    },
    updateEndSaleDate(key, dateObj, thisObj) {
      let vm = this;
      vm.unitData.EndSaleDate = dateObj ? dateObj.format("DD MMM YYYY") : null;
      console.log("vm.unitData.EndSaleDate", vm.unitData.EndSaleDate);
      // vm.getHouseKeepinglist();
    },
    syncUnitDetailsToRU(ruSyncMethodsList, rentalUnitedClient) {
      let vm = this;
      let ruSyncMethods = ruSyncMethodsList.filter(
        (col) => col.IsChecked == true
      );
      let syncMethods = ruSyncMethods.map((obj) => obj.method);
      console.log("ruSyncMethods===>", syncMethods);
      for (let method of syncMethods) {
        vm.syncUnitToRU(method, rentalUnitedClient);
      }
    },
    getAccountDetails(e) {
      let vm = this;
      if (e.target.checked) {
        vm.IsActive = 1;
      } else {
        vm.IsActive = 0;
      }
      vm.Get_PaymentAccount_Details();
    },
    changeInCommisssion() {
      let vm = this;
      vm.commissionPercentColor = "yellowColor";
    },
    editDefaultValue(e) {
      let vm = this;
      if (e.target.checked) {
        vm.unitData.UseDefault = 1;
        // vm.getClientDetailByid();
        //CommissionAmount: null,
        //commissionPercent: null
        vm.CommissionAmount = vm.unitData.DefaultCommissionAmount;
        vm.commissionPercent = vm.unitData.DefaultCommissionType;
        if (vm.commissionPercent == true) {
          vm.commissionPercent = 1;
        } else if (vm.commissionPercent == false) {
          vm.commissionPercent = 0;
        }
        vm.editDefault = true;
      } else {
        vm.unitData.UseDefault = 0;
        vm.editDefault = false;
        vm.CommissionAmount = vm.unitData.CommissionAmount;
        vm.commissionPercent = vm.unitData.IsPercent;
        if (vm.commissionPercent == true) {
          vm.commissionPercent = 1;
        } else if (vm.commissionPercent == false) {
          vm.commissionPercent = 0;
        }
      }
    },
    makePaymentAccountDefault(paymentAccount) {
      let vm = this;
      let classsName = "#" + this.paymentAccountEdit;
      $(classsName).removeClass("show");
      // paymentAccount.IsDefault = true;
      vm.selectedPaymentAccount = paymentAccount;
      console.log(
        "paymentAccount-mk--",
        paymentAccount,
        vm.selectedPaymentAccount
      );
      // vm.Save_Acc_Commission_Config({accountId: paymentAccount.PaymentAccountId,statusId: 1,IsDefault: 1});
      vm.isModalVisible = true;
      vm.modalParams = {
        popupTitle: `${
          paymentAccount.GatewayId === 1 ? "Stripe" : "Clearview Payment"
        }`,
        popupMessage: `Do you want to make Stripe Payments your Default payment processor?`,
        isRUPopup: true,
        yesButtontext: "Yes",
        noButtonText: "No",
        yesButtonCallback: vm.Update_Acc_Commission_Config,
        noButtonCallback: vm.closePopup,
      };
      // vm.Update_Acc_Commission_Config(paymentAccount);
    },
    removePaymentAccount(paymentAccount, statusId) {
      let vm = this;
      let classsName = "#" + this.paymentAccountEdit;
      $(classsName).removeClass("show");
      paymentAccount.StatusId = statusId;
      paymentAccount.IsDefault = false;
      vm.Update_Acc_Commission_Config(paymentAccount);
    },
    Update_Acc_Commission_Config(paymentAccount) {
      let vm = this;
      if (vm.selectedPaymentAccount && vm.selectedPaymentAccount.GatewayId) {
        vm.selectedPaymentAccount.IsDefault = true;
      }

      paymentAccount = paymentAccount.GatewayId
        ? paymentAccount
        : vm.selectedPaymentAccount;
      console.log(
        "update---paymenttac----",
        paymentAccount,
        vm.selectedPaymentAccount,
        paymentAccount.IsDefault
      );

      vm.$store.dispatch("dataRequestHandler", {
        key: "Update_Acc_Commission_Config",
        params: {
          ModuleAction: "Update_Acc_Commission_Config",
          propertyId: vm.unitData.PropertyId,
          unitId: vm.unitID,
          isClient: true,
          paymentAccount: paymentAccount,
          CommissionPercent: vm.commissionPercent,
          CommissionAmmount: vm.CommissionAmount,
          UseDefault: vm.unitData.UseDefault,
          IsLive: vm.IsLive == true ? 1 : 0,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            if (
              response[0] &&
              response[0].length > 0 &&
              response[0][0].ErrorMessage
            ) {
              vm.$store.dispatch("toastr", {
                type: "error",
                message: "Error!",
                header: "unable to update",
              });
            } else {
              vm.$store.dispatch("toastr", {
                type: "success",
                message: "Updated the account successfully",
                header: "",
              });
              vm.Get_PaymentAccount_Details();
              vm.getUnitDetailById();
            }
            console.log("response in Get_PaymentAccount_Details", response);
          }
        },
      });
      vm.isModalVisible = false;
    },
    showAccountEdit(index) {
      let vm = this;
      setTimeout(function () {
        vm.paymentAccountEdit = "accountEdit" + index;
        let classsName = "#" + vm.paymentAccountEdit;
        $(classsName).addClass("show");
      }, 10);
    },
    savePaymentSetupDetails() {
      let vm = this;
    },
    imageUrls(imgGuid) {
      let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid);
      if (isBase64) {
        return imgGuid;
      }
      return this.apiUrl + "/downloadImage/" + imgGuid + "/430x300";
    },
    thumbnailImageUrl(imgGuid){
      let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid);
      if (isBase64) {
        return imgGuid;
      }
      return this.apiUrl + "/downloadImage/" + imgGuid + "/null";
    },
    AmenitySave(e, Aminity) {
      if (e.target.checked) {
        return;
      } else {
        var index = this.AminitiesData.indexOf(Aminity);
        this.AminitiesData[index].IsChecked = 0;
        var index2 = this.AminitiesData.indexOf(Aminity.ListId);
        if (index2 > -1) {
          this.checkedAminities.splice(index2, 1);
        }
        console.log(
          "checked amineties========>",
          JSON.stringify(this.AminitiesData)
        );
        console.log("checkedAminities=>", this.checkedAminities);
      }
    },
    // processLogo(e) {
    //   let files = e.target.files || e.dataTransfer.files;
    //   if (!files.length) {
    //     this.unitData.UnitLogo = null;
    //     return;
    //   } else {
    //     this.createImage(files[0]);
    //   }
    // },
    // createImage(file) {
    //   let reader = new FileReader();
    //   let vm = this;
    //   reader.onload = e => {
    //     vm.image = e.target.result;
    //     vm.unitData.UnitLogo = vm.image;

    //   };
    //   reader.readAsDataURL(file);
    // },
    // uploadImages(e) {
    //   let files = e.target.files || e.dataTransfer.files;
    //   if (!files.length) {
    //     this.unitData.UnitLogo = null;
    //     return;
    //   } else {
    //     this.createImage(files[0]);
    //   }
    // },
    updateSortImages(evt) {
      debugger;
      let vm = this;
      console.log(this.imageArr);
      let url = this.apiUrl + "/upload";
      vm.imageData.splice(0, vm.imageData.length);
      let imageIds = [];
      for (var i = 0; i < vm.imageArr.length; i++) {
        imageIds.push(vm.imageArr[i].ImageId);
      }
      imageIds.sort(function (a, b) {
        return a - b;
      });
      for (var i = 0; i < vm.imageArr.length; i++) {
        let obj = {};
        obj.ImageUrl = vm.imageArr[i].ImageUrl;
        obj.ImageId = imageIds[i];

        vm.imageData.push(obj);
      }
      vm.saveImages();
    },

    uploadImages(e) {
      let vm = this;
      if (vm.unitID === -1) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "can't upload  until first section details get saved",
        });
      } else {
        this.imageData = [];
        let files = e.target.files || e.dataTransfer.files;
        for (var i = 0; i < files.length; i++) {
          this.imageData.push(files[i]);
        }
        if (!files.length) {
          this.unitData.UnitLogo = null;
          return;
        } else {
          this.createImage(files[0]);
        }
      }
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
        vm.unitData.UnitLogo = vm.image;

        // console.log("image===================>", vm.image);
        // vm.imageArr.push(vm.image);
        console.log("vm.imageArr", vm.imageArr);
        const formData = new FormData();
        Array.from(Array(this.imageData.length).keys()).map((x) => {
          formData.append("photos", this.imageData[x], this.imageData[x].name);
        });
        console.log(this.apiUrl + "/upload");
        let url = this.apiUrl + "/upload";
        let obj = {};
        obj.ImageUrl = vm.image;
        obj.ImageId = -1;

        vm.imageArr.push(obj);

        // console.log("base64" + vm.propertyImages);
        axios.post(url, formData).then((data) => {
          console.log(data.data, data.data.length);
          // vm.imageArr.splice(-1, data.data.length);
          console.log("vm.imageArr.splice(-1, data.data.length);", vm.imageArr);
          vm.imageData.splice(0, vm.imageData.length);

          for (let img of data.data) {
            // vm.imageArr.push(apiUrl + '/downloadImage/'+img.imageGuid)
            let obj = {};
            obj.ImageUrl = img.imageGuid;
            obj.ImageId = -1;
            // vm.imageArr.splice(-1,1);
            //vm.imageArr.push(obj);
            vm.imageData.push(obj);
          }
          console.log(vm.imageArr);
          vm.saveImages();
        });
      };
      reader.readAsDataURL(file);
    },
    show(index) {
      let scope = this;
      scope.imgs = [];
      scope.index = index;
      scope.visible = true;
      for (var x in scope.imageArr) {
        scope.imgs.push(
          this.apiUrl + "/downloadImage/" + scope.imageArr[x].ImageUrl + "/null"
        );
      }
    },
    handleHide() {
      this.visible = false;
    },

    // removeImage(images) {
    //   let scope = this;
    //   var index = scope.unitImages.indexOf(images);
    //   console.log("index============>", index);
    //   if (index > -1) {
    //     scope.unitImages.splice(index, 1);
    //   }
    // },
    // addUnit: function () {
    //   let vm = this;
    //   vm.checkedAminities = [];
    //   if (vm.AminitiesData && vm.AminitiesData.length > 0) {
    //     for (let AminitiesDataIndex = 0; AminitiesDataIndex < vm.AminitiesData.length; AminitiesDataIndex++) {

    //       if (Number(vm.AminitiesData[AminitiesDataIndex]["IsChecked"])) {
    //         console.log("ami name ===================>>>>>>>>>>>>>>>>>", vm.AminitiesData[AminitiesDataIndex].ListName)
    //         vm.checkedAminities.push(vm.AminitiesData[AminitiesDataIndex]["ListId"]);
    //       }
    //     }
    //   }
    //   console.log("checkedAminities=>", vm.checkedAminities);

    //   if (!vm.unitData.IsSync) {
    //     console.log("!unitData.IsSync", vm.unitData.IsSync);
    //     vm.unitData.IsSync = 0;
    //   }
    //   if ((vm.unitData.UnitName === "" || vm.unitData.UnitName === undefined) || (vm.unitData.BedRooms === "" || vm.unitData.BedRooms === null) || (vm.unitData.NickName === "" || vm.unitData.NickName === undefined)) {

    //     vm.$store.dispatch("toastr", {
    //       type: "warning",
    //       header: "Warning",
    //       message: "UnitName,  NickName,  BedRooms fields are mandatary"
    //     });
    //   }
    //   else {

    //     console.log("in add unit detail");
    //     vm.$validator.validateAll().then((result) => {
    //       if (result) {
    //         let unitObj = {
    //           UnitClassId: vm.selectedUnitClassObj.UnitClassId,
    //           UnitId: vm.unitData.UnitId,
    //           PropertyId: vm.unitData.PropertyId,
    //           UnitName: vm.unitData.UnitName,
    //           NickName: vm.unitData.NickName,
    //           Description: vm.unitData.Description,
    //           unitLogo: vm.unitData.UnitLogo,

    //           turnOverCleaningCharge: vm.unitData.turnOverCleaningCharge,
    //           interimCleaningCharge: vm.unitData.interimCleaningCharge,

    //           BedRooms: vm.unitData.BedRooms,
    //           UnitClassId: vm.selectedUnitClassObj.UnitClassId,
    //           UnitRank: vm.unitData.UnitRank,
    //           SortOrder: vm.unitData.SortOrder,
    //           StatusId: vm.status.StatusId,
    //           UnitNumber: vm.unitData.UnitNumber,
    //           MaxAdults: vm.unitData.MaxAdults,
    //           MaxPersons: vm.unitData.MaxPersons,

    //           AmountInWeekday: vm.unitData.WeekdayRate,
    //           NoOfPersonsInWeekday: vm.unitData.MaxPersons_Weekday,
    //           AdditionalNoOfAdultsInWeekday: vm.unitData.AdditionalAdult_WeekdayRate,
    //           AdditionalNoOfChildrenInWeekday: vm.unitData.AdditionalChild_WeekdayRate,
    //           AmountInWeekend: vm.unitData.WeekendRate,
    //           NoOfPersonsInWeekend: vm.unitData.MaxPersons_Weekend,
    //           AdditionalNoOfAdultsInWeekend: vm.unitData.AdditionalAdult_WeekendRate,
    //           AdditionalNoOfChildrenInWeekend: vm.unitData.AdditionalChild_WeekendRate,
    //           FunctionId: 'fncPropertySave',
    //           checkedAminities: vm.checkedAminities,
    //           IsSync: vm.unitData.IsSync

    //         };

    //         vm.$store.dispatch("dataRequestHandler", {
    //           key: "AddUnitDetail",
    //           params: {
    //             ModuleAction: "AddUnitDetail",
    //             unitData: unitObj,

    //           },
    //           callback: function (error, response) {
    //             console.log("getdetailsunit", response);

    //             if (error) {
    //               console.error("Error has occured => ", error);
    //               vm.$store.dispatch("toastr", {
    //                 type: "error",
    //                 header: "Unit Group Instance Detail Error!",
    //                 message: error.sqlMessage ? error.sqlMessage : error
    //               });
    //             } else if (response) {

    //               console.log("AddUnitDetail", response);

    //               console.log("vm.UnitId", vm.UnitId);
    //               if (response.recordsets[0][0] && response.recordsets[0][0].ErrorMessage !== "") {
    //                 vm.$store.dispatch("toastr", {
    //                   type: "error",
    //                   header: "Error While saving",
    //                   message: response.recordsets[0][0].ErrorMessage
    //                 });
    //               }
    //               else {
    //                 vm.$store.dispatch("toastr", {
    //                   type: "success",
    //                   header: "Success!",
    //                   message: "Unit detail successfully saved"
    //                 });
    //               }

    //             }

    //             let UnitId = response.recordsets[1][0].UnitId;
    //             let PropertyId = response.recordsets[1][0].PropertyId
    //             console.log("checking unitId", UnitId);
    //             console.log("checking PropertyId", PropertyId);
    //             vm.$router.push("/unitDetail/" + UnitId + "/" + PropertyId);

    //           }

    //         });

    //       }
    //     });
    //   }
    // },
    closePopup() {
      let vm = this;
      vm.isModalVisible = false;
      vm.Unit_Status = {
        StatusId: vm.unitData.StatusId,
        StatusName: vm.unitData.StatusName,
      };
    },
    saveUnitFirstSection() {
      let vm = this;
      if (
        (vm.Unit_Status.StatusId == 0 ||
          vm.Unit_Status.StatusId == -1 ||
          vm.Unit_Status.StatusId == -2) &&
        (vm.unitData.Suiteexists == 1 || vm.unitData.Suiteexists == true)
      ) {
        vm.isModalVisible = true;
        vm.modalParams = {
          popupTitle: "Update Unit Status",
          popupMessage:
            `Making this Unit ${vm.Unit_Status.StatusName} will make all related Suites ` +
            `${vm.Unit_Status.StatusName}.  

                  Do you want to proceed?`,
          yesButtontext: "Proceed",
          noButtonText: "Cancel",
          yesButtonCallback: vm.saveUnitInfo,
          noButtonCallback: vm.closePopup,
        };
        vm.updatesuite = 1;
      } else {
        vm.isModalVisible = false;
        vm.saveUnitInfo();
        vm.updatesuite = 0;
      }
    },
    activateUnitandCrsPropertyMapping(
      ruIntegarationscreen,
      rentalUnitedClient
    ) {
      let vm = this;
      rentalUnitedClient =
        rentalUnitedClient && rentalUnitedClient.UserName
          ? rentalUnitedClient
          : vm.selectedRuClientAccountList;
      if (
        vm.unitConnectedRuAccount.length > 0 &&
        rentalUnitedClient.UserName != vm.unitConnectedRuAccount[0].UserName &&
        rentalUnitedClient.IntegrationId == 1
      ) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "warning!",
          message:
            "Can not push data to ru due to unit is mapped with other RU account",
        });
        return;
      }

      // let selectedRUAccount = vm.ruClientAccountList.filter(ruaccount => ruaccount.IsDefault && ruaccount.StatusId == 1)
      vm.$store.dispatch("dataRequestHandler", {
        key: "Save_CrsPropertyDetails",
        params: {
          CrsId: 2,
          UnitId: vm.unitID,
          IsActive: vm.unitData.StatusId == 1 ? true : false,
          PropertyId: vm.crsPropertyId
            ? vm.crsPropertyId
            : rentalUnitedClient.CrsPropertyId,
          username: rentalUnitedClient.UserName,
          Password: rentalUnitedClient.Password,
          CrsResponse: null,
          MessageId: null,
          ruIntegarationscreen: ruIntegarationscreen ? true : false,
          ownerId: vm.crsOwnerId ? vm.crsOwnerId : rentalUnitedClient.OwnerId, //RUproperty.CrsOwnerId
        },
        callback: function (error, response) {
          console.log("Save_CrsPropertyDetails response", response);
          if (error) {
            if (vm.unitData.StatusId == 1) {
              vm.$store.dispatch("toastr", {
                type: "error",
                message: "Unable to activate",
                header: "Error!",
              });
            }
            return;
          }
          if (vm.unitData.StatusId == 1) {
            if (
              response[0] &&
              response[0].length > 0 &&
              response[0][0].ErrorMessage &&
              response[0][0].ErrorMessage.trim() != ""
            ) {
              vm.$store.dispatch("toastr", {
                type: "error",
                message: "Unable to activate",
                header: "Error!",
              });
            } else {
              vm.$store.dispatch("toastr", {
                type: "success",
                message: "Success!",
                header: "Activated Successfully",
              });
              vm.loadUnitDetails(rentalUnitedClient);
            }
          }
        },
      });
    },
    loadUnitDetails(rentalUnitedClient) {
      var vm = this;
      vm.getUnitDetailById();
      if (rentalUnitedClient) {
        vm.$refs.RUIntegration.pullPropertyList(rentalUnitedClient);
      }
      vm.$refs.RUIntegration.getRentalUnitedClients();
    },
    // save section
    saveUnitInfo: function () {
      console.log("save1");
      let vm = this;
      vm.isModalVisible = false;
      this.$validator.validateAll().then((result) => {
        if (result) {
          vm.$store.dispatch("dataRequestHandler", {
            key: "AddUnitDetail",
            params: {
              section: "saveUnitInformation1",
              UnitId: vm.unitID,
              PropertyId: vm.unitData.PropertyId,
              UnitName: vm.unitData.UnitName,
              NickName: vm.unitData.NickName,
              UnitClassId: vm.selectedUnitClassObj.UnitClassId,
              unitTypeId: vm.selectedUnitTypeObj.UnitTypeId,
              StatusId: vm.Unit_Status.StatusId,
              StartSaleDate: vm.unitData.StartSaleDate
                ? vm.unitData.StartSaleDate
                : null,
              EndSaleDate: vm.unitData.EndSaleDate
                ? vm.unitData.EndSaleDate
                : null,
              UnitSettings_UnitType: vm.unitData.UnitSettings_UnitType,
              RatesRestrictions_UnitType:
                vm.unitData.RatesRestrictions_UnitType,
              UnitSetId: vm.unitData.unitSetId,
              updatesuite: vm.updatesuite,
              FloorValue: vm.unitData.FloorValue,
              SpaceValue: vm.unitData.SpaceValue,
              EnableReservationNotifications:
                vm.unitData.EnableReservationNotifications,
              integrationAccounrList: vm.ruClientAccountList,
            },
            callback: function (error, response) {
              console.log("saveUnitInfo response", response);
              if (error) {
                console.log("Error has occured => ", error);
                vm.$store.dispatch("toastr", {
                  type: "error",
                  header: "saveUnitInfo  Error!",
                  message: error.sqlMessage ? error.sqlMessage : error,
                });
                return;
              } else if (response) {
                console.log("AddUnitDetail", response);

                console.log("vm.UnitId", vm.UnitId);
                if (
                  response.recordsets[0][0] &&
                  response.recordsets[0][0].ErrorMessage !== ""
                ) {
                  vm.$store.dispatch("toastr", {
                    type: "error",
                    header: "Error While saving",
                    message: response.recordsets[0][0].ErrorMessage,
                  });
                } else {
                  vm.$store.dispatch("toastr", {
                    type: "success",
                    header: "Success!",
                    message: "Unit Info  successfully saved",
                  });
                }
              }
              // if(response.recordsets[5] && response.recordsets[5].length > 0 ){

              // }
              vm.section1val = true;
              vm.unitID = response.recordsets[1][0].UnitId;
              let PropertyId = response.recordsets[1][0].PropertyId;
              console.log("checking unitId", vm.unitID);
              console.log("checking PropertyId", PropertyId);
              if (vm.crsPropertyId && vm.$route.params.unitId == -1) {
                vm.activateUnitandCrsPropertyMapping();
              }
              vm.$router.push("/unitDetail/" + vm.unitID + "/" + PropertyId);
              if (
                (vm.unitData.RatesRestrictions_UnitType == 1 ||
                  vm.unitData.RatesRestrictions_UnitType == true) &&
                !vm.IsRatesRestrictions
              ) {
                vm.UpdateRatesandRestriction_unit_unittype(1);
              } else if (
                (vm.unitData.RatesRestrictions_UnitType == 0 ||
                  vm.unitData.RatesRestrictions_UnitType == false) &&
                !vm.IsRatesRestrictions
              ) {
                vm.UpdateRatesandRestriction_unit_unittype(0);
              }
              vm.getUnitDetailById();
              if (
                response &&
                response.recordsets &&
                response.recordsets[2] &&
                response.recordsets[2].length > 0 &&
                response.recordsets[2][0].SyncUnit == 1 &&
                response.recordsets[2][0].syncToRU == 1
              ) {
                for (let ruaccount of vm.ruClientAccountList) {
                  if (ruaccount.CrsStatus == 3) {
                    if (vm.Unit_Status.StatusId != 1) {
                      vm.activateUnitandCrsPropertyMapping(true, ruaccount);
                    } else {
                      vm.syncUnitToRU("Property Sync", ruaccount);
                    }
                  }
                }
              }
            },
          });
        }
      });
    },
    UpdateRatesandRestriction_unit_unittype(bit) {
      let vm = this;
      console.log("bitbitbitbitbitbit=>", bit);
      vm.$store.dispatch("dataRequestHandler", {
        key: "UpdateRatesandRestriction_unit_unittype",
        params: {
          ModuleAction: "UpdateRatesandRestriction_unit_unittype",
          UnitTypeid: vm.selectedUnitTypeObj.UnitTypeId,
          UnitId: vm.unitID,
          OverridefromUnitType: bit,
        },
        callback: function (error, response) {
          if (error) {
            console.error("Error has occured => ", error);

            return;
          } else {
            vm.getUnitDetailById();
          }
        },
      });
    },

    saveUnit_DescImages: function () {
      let vm = this;
      if (vm.unitID === -1) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "please enter Unit Details",
        });
      } else {
        if(!vm.unitData.Description){
          vm.$store.dispatch("toastr", {
          type: "warning",
          header: "",
          message: "Please fill the description field"
          });
          return;
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "AddUnitDetail",
          params: {
            section: "saveUnitInformation2",
            UnitId: vm.unitID,
            PropertyId: vm.unitData.PropertyId,
            Description: vm.unitData.Description, //.replace(/\n/g, '<br>'),
            URL: vm.unitData.URL,
          },
          callback: function (error, response) {
            console.log("Amenities response", response);
            if (error) {
              console.error("Error has occured => ", error);
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Description Info Error!",
                message: error.sqlMessage ? error.sqlMessage : error,
              });
              return;
            } else {
              // var clientIdURL = response.recordsets[2][0].ClientId;

              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Description  successfully saved",
              });
              vm.section2val = true;
              vm.getImages();
            }
            // vm.unitID = response.recordsets[1][0].UnitId;
            // let PropertyId = response.recordsets[1][0].PropertyId
            // console.log("checking unitId", vm.unitID);
            // console.log("checking PropertyId", PropertyId);
            // vm.$router.push("/unitDetail/" + vm.unitID + "/" + PropertyId);
          },
        });
      }
    },
    saveImages(imageArr) {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "saveAWS_Image",
        params: {
          ModuleAction: "saveAWS_Image",
          propertyId: vm.unitData.PropertyId,
          images: vm.imageData,
          UnitId: vm.unitID,
          BE_Id: null,
        },
        callback: function (error, response) {
          if (error) {
            console.error("Error has occured => ", error);

            return;
          } else {
            // console.log(params);
            vm.$store.dispatch("toastr", {
              type: "success",
              header: "Success!",
              message: "Image successfully saved",
            });
            vm.getImages();
          }
        },
      });
    },
    getImageId(id) {
      this.selectedImageId = id;
    },
    upDateimg(e) {
      // console.log("ImageIdImageId",ImageId);
      let files = e.target.files || e.dataTransfer.files;
      this.imageData.push(files[0]);
      if (!files.length) {
        //update image
        this.unitData.UnitLogo = null;
        return;
      } else {
        this.createUpdateImage(files[0], this.selectedImageId);
      }
    },
    createUpdateImage(file, ImageId) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
        // vm.image = e.target.result;
        // vm.propertyData.propertyContent.PropertyLogo = vm.image;

        // console.log("image===================>", vm.image);
        // vm.imageArr.push(vm.image);
        const formData = new FormData();
        Array.from(Array(this.imageData.length).keys()).map((x) => {
          formData.append("photos", this.imageData[x], this.imageData[x].name);
        });
        console.log(this.apiUrl + "/upload");
        let url = this.apiUrl + "/upload";
        // let obj = {};
        // obj.ImageUrl = e.target.result;
        // obj.ImageId = -1;

        // vm.imageArr.push(obj);

        axios.post(url, formData).then((data) => {
          // console.log(data.data, data.data.length);

          // console.log("vm.imageArr.splice(-1, data.data.length);", vm.imageArr);
          let obj = {};
          obj.ImageId = ImageId;
          obj.ImageUrl = data.data[0].imageGuid;

          let imageIndex = vm.imageArr.findIndex((x) => x.ImageId == ImageId);
          vm.imageArr[imageIndex] = obj;
          vm.removeImage(obj.ImageUrl, imageIndex, false);

          // vm.saveImages()
          // vm.imageData.splice(0, vm.imageData.length);

          // for (let img of data.data) {

          //   let obj = {};
          //   obj.ImageUrl = img.imageGuid;
          //   obj.ImageId = -1;

          //   vm.imageData.push(obj);
          // }
          console.log(vm.imageArr);
          // vm.saveImages();
        });
      };
      reader.readAsDataURL(file);
    },
    removeImage(imageGuid, index, isdelete) {
      console.log("imagesimages", imageGuid);
      let vm = this;
      // console.log("vm.imageArr[index]",vm.imageArr[index].ImageId);
      vm.$store.dispatch("dataRequestHandler", {
        key: "DeleteImages",
        params: {
          ModuleAction: "deleteImages",
          ImageId: vm.imageArr[index].ImageId,
          ImageUrl: vm.imageArr[index].ImageUrl,
          isdelete: isdelete,
        },
        callback: function (err, response) {
          console.log("image call back==>", response);
          if (err) {
            console.error("Error has occured => ", err);
            vm.$store.dispatch("toastr", {
              type: "error",
              header: "error!",
              message: error.sqlMessage ? error.sqlMessage : err,
            });
            return;
          } else if (response[0][0] && response[0][0].isEdited === true) {
            vm.$store.dispatch("toastr", {
              type: "success",
              header: "Success!",
              message: "successfully image updated",
            });
          } else {
            vm.$store.dispatch("toastr", {
              type: "success",
              header: "Success!",
              message: "successfully image deleted",
            });
          }

          vm.getImages();
        },
      });
    },

    saveUnit_MiscInfo: function () {
      let vm = this;

      if (vm.unitID === -1) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "please enter Unit Details",
        });
      } else {
        vm.$validator.validateAll().then((result) => {
          if (result) {
            vm.$store.dispatch("dataRequestHandler", {
              key: "AddUnitDetail",
              params: {
                section: "saveUnitInformation3",
                UnitId: vm.unitID,
                UnitRank: vm.unitData.UnitRank,
                UnitNumber: vm.unitData.UnitNumber,
                PropertyId: vm.unitData.PropertyId,
                turnOverCleaningCharge: vm.unitData.turnOverCleaningCharge,
                interimCleaningCharge: vm.unitData.interimCleaningCharge,
                BedRooms: vm.unitData.BedRooms,
                Beds: vm.unitData.NoOfBeds,
                Bathrooms: vm.unitData.NoOfBathrooms,
                BARate: vm.unitData.BARate,
                PetFee: vm.unitData.PetFee,
              },
              callback: function (error, response) {
                console.log("unit1 response", response);
                if (error) {
                  console.error("Error has occured => ", error);
                  vm.$store.dispatch("toastr", {
                    type: "error",
                    header: "Unit Class Info Error!",
                    message: error.sqlMessage ? error.sqlMessage : error,
                  });
                  return;
                } else {
                  // var clientIdURL = response.recordsets[2][0].ClientId;

                  vm.$store.dispatch("toastr", {
                    type: "success",
                    header: "Success!",
                    message: "Unit Class Info successfully saved",
                  });
                  vm.section3val = true;
                  vm.getUnitDetailById();
                  if (
                    response &&
                    response.recordsets &&
                    response.recordsets[2] &&
                    response.recordsets[2].length > 0 &&
                    response.recordsets[2][0].SyncUnit == 1 &&
                    response.recordsets[2][0].syncToRU == 1
                  ) {
                    for (let ruaccount of vm.ruClientAccountList) {
                      if (ruaccount.CrsStatus == 3) {
                        vm.syncUnitToRU("Property Sync", ruaccount);
                      }
                    }
                  }
                }
                // vm.unitID = response.recordsets[1][0].UnitId;
                // let PropertyId = response.recordsets[1][0].PropertyId
                // console.log("checking unitId", vm.unitID);
                // console.log("checking PropertyId", PropertyId);
                // vm.$router.push("/unitDetail/" + vm.unitID + "/" + PropertyId);
              },
            });
          }
        });
      }
    },
    saveUnit_Occupancy: function () {
      let vm = this;
      if (vm.unitID === -1) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "please enter Unit Details",
        });
      } else if (!vm.unitData.SortOrder) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "Please enter Sort order",
        });
      } else if (
        isNaN(vm.unitData.SortOrder) ||
        Number(vm.unitData.SortOrder) < 1
      ) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "Please enter valid Sort order",
        });
      } else {
        vm.$store.dispatch("dataRequestHandler", {
          key: "AddUnitDetail",
          params: {
            section: "saveUnitInformation4",
            UnitId: vm.unitID,
            SortOrder: vm.unitData.SortOrder,
            MaxAdults: vm.unitData.MaxAdults,
            MaxPersons: vm.unitData.MaxPersons,
            MaxChildren: vm.unitData.MaxChildren,
            PropertyId: vm.unitData.PropertyId,
          },
          callback: function (error, response) {
            console.log("unit4 response", response);
            if (error) {
              console.error("Error has occured => ", error);
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Unit Capacity Info Error!",
                message: error.sqlMessage ? error.sqlMessage : error,
              });
              return;
            } else {
              // var clientIdURL = response.recordsets[2][0].ClientId;
              if (response.recordsets[0][0]["ErrorMessage"]) {
                vm.$store.dispatch("toastr", {
                  type: "error",
                  header: "Validation Errors!",
                  message: response.recordsets[0][0]["ErrorMessage"],
                });
                return;
              } else {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message: "Unit Capacity  successfully saved",
                });
              }
              vm.section4val = true;
              vm.getUnitDetailById();
            }
            // vm.unitID = response.recordsets[1][0].UnitId;
            // let PropertyId = response.recordsets[1][0].PropertyId
            // console.log("checking unitId", vm.unitID);
            // console.log("checking PropertyId", PropertyId);
            // vm.$router.push("/unitDetail/" + vm.unitID + "/" + PropertyId);
          },
        });
      }
    },
    saveUnit_WeekdayCharges: function () {
      console.log("save1");
      let vm = this;
      if (vm.unitID === -1) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "please enter Unit Details",
        });
      } else {
        vm.$store.dispatch("dataRequestHandler", {
          key: "AddUnitDetail",
          params: {
            section: "saveUnitInformation5",
            UnitId: vm.unitID,
            WeekdayRate: vm.unitData.WeekdayRate,
            AdditionalAdult_WeekdayRate:
              vm.unitData.AdditionalAdult_WeekdayRate,
            AdditionalChild_WeekdayRate:
              vm.unitData.AdditionalChild_WeekdayRate,
            MaxPersons_Weekday: vm.unitData.MaxPersons_Weekday,
            PropertyId: vm.unitData.PropertyId,
          },
          callback: function (error, response) {
            console.log("unit1 response", response);
            if (error) {
              console.error("Error has occured => ", error);
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Weekday Rate Error!",
                message: error.sqlMessage ? error.sqlMessage : error,
              });
              return;
            } else {
              // var clientIdURL = response.recordsets[2][0].ClientId;

              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Weekday Rate successfully saved",
              });
              vm.section5val = true;
              vm.getUnitDetailById();
              for (let ruaccount of vm.ruClientAccountList) {
                  if (ruaccount.CrsStatus == 3) {
                    // if (vm.Unit_Status.StatusId != 1) {
                    //   vm.activateUnitandCrsPropertyMapping(true, ruaccount);
                    // } else {
                      vm.syncUnitToRU("Rates", ruaccount);
                    // }
                  }
                }
            }
            // vm.unitID = response.recordsets[1][0].UnitId;
            // let PropertyId = response.recordsets[1][0].PropertyId
            // console.log("checking unitId", vm.unitID);
            // console.log("checking PropertyId", PropertyId);
            // vm.$router.push("/unitDetail/" + vm.unitID + "/" + PropertyId);
          },
        });
      }
    },
    saveUnit_WeekendCharges: function () {
      console.log("save6");
      let vm = this;
      if (vm.unitID === -1) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "please enter Unit Details",
        });
      } else {
        vm.$store.dispatch("dataRequestHandler", {
          key: "AddUnitDetail",
          params: {
            section: "saveUnitInformation6",
            UnitId: vm.unitID,
            WeekendRate: vm.unitData.WeekendRate,
            AdditionalAdult_WeekendRate:
              vm.unitData.AdditionalAdult_WeekendRate,
            AdditionalChild_WeekendRate:
              vm.unitData.AdditionalChild_WeekendRate,
            MaxPersons_Weekend: vm.unitData.MaxPersons_Weekend,
            PropertyId: vm.unitData.PropertyId,
          },
          callback: function (error, response) {
            console.log("unit1 response", response);
            if (error) {
              console.error("Error has occured => ", error);
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Weekend Rate  Error!",
                message: error.sqlMessage ? error.sqlMessage : error,
              });
              return;
            } else {
              // var clientIdURL = response.recordsets[2][0].ClientId;
              vm.section6val = true;
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Weekend Rate  successfully saved",
              });

              vm.getUnitDetailById();
              for (let ruaccount of vm.ruClientAccountList) {
                  if (ruaccount.CrsStatus == 3) {
                    // if (vm.Unit_Status.StatusId != 1) {
                    //   vm.activateUnitandCrsPropertyMapping(true, ruaccount);
                    // } else {
                      vm.syncUnitToRU("Rates", ruaccount);
                    // }
                  }
                }
            }
            // vm.unitID = response.recordsets[1][0].UnitId;
            // let PropertyId = response.recordsets[1][0].PropertyId
            // console.log("checking unitId", vm.unitID);
            // console.log("checking PropertyId", PropertyId);
            // vm.$router.push("/unitDetail/" + vm.unitID + "/" + PropertyId);
          },
        });
      }
    },
    saveAmenities: function () {
      let vm = this;
      if (vm.unitID === -1) {
        vm.$store.dispatch("toastr", {
          type: "warning",
          header: "Warning",
          message: "please enter Unit Details",
        });
      } else {
        vm.checkedAminities = [];
        if (vm.AminitiesData && vm.AminitiesData.length > 0) {
          for (
            let AminitiesDataIndex = 0;
            AminitiesDataIndex < vm.AminitiesData.length;
            AminitiesDataIndex++
          ) {
            if (Number(vm.AminitiesData[AminitiesDataIndex]["IsChecked"])) {
              console.log(
                "ami name ====>>",
                vm.AminitiesData[AminitiesDataIndex].ListName
              );
              vm.checkedAminities.push(
                vm.AminitiesData[AminitiesDataIndex]["ListId"]
              );
            }
          }
        }
        console.log("checkedAminities=>", vm.checkedAminities);

        if (!vm.unitData.IsSync) {
          console.log("!unitData.IsSync", vm.unitData.IsSync);
          vm.unitData.IsSync = 0;
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "AddUnitDetail",
          params: {
            section: "saveUnitInformation7",
            UnitId: vm.unitID,
            checkedAminities: vm.checkedAminities,
            // IsSync: vm.unitData.IsSync,
            PropertyId: vm.unitData.PropertyId,
          },
          callback: function (error, response) {
            console.log("unit1 response", response);
            if (error) {
              console.error("Error has occured => ", error);
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Amenities  Error!",
                message: error.sqlMessage ? error.sqlMessage : error,
              });
              return;
            } else {
              // var clientIdURL = response.recordsets[2][0].ClientId;
              vm.section7val = true;
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Amenities  successfully saved",
              });

              vm.getUnitDetailById();
            }
            // vm.unitID = response.recordsets[1][0].UnitId;
            // let PropertyId = response.recordsets[1][0].PropertyId;
            // console.log("checking unitId", vm.unitID);
            // console.log("checking PropertyId", PropertyId);
            // vm.$router.push("/unitDetail/" + vm.unitID + "/" + PropertyId);
          },
        });
      }
    },
    getunitclassByproperty() {
      let scope = this;
      if (scope.unitData.PropertyId) {
        // let actualUnitClassList = JSON.parse(JSON.stringify(scope.actualUnitClassList))
        let selectedPropertyUnitclass = scope.actualUnitClassList.filter(
          (unitclss) => unitclss.PropertyId == scope.unitData.PropertyId
        );
        scope.UnitClass.splice(
          0,
          scope.UnitClass.length,
          ...selectedPropertyUnitclass
        );
        let selectedPropertyAmenities = scope.actualCrsAmenities.filter(
          (unitami) => unitami.PropertyId == scope.unitData.PropertyId
        );
        scope.crsAmenities.splice(
          0,
          scope.crsAmenities.length,
          ...selectedPropertyAmenities
        );
        console.log(
          "scope.actualUnitClassList grt by property= ",
          scope.actualUnitClassList
        );
        if (
          scope.UnitClass.length > 0 &&
          scope.ruPropertyObj &&
          scope.ruPropertyObj.Pull_ListSpecProp_RS &&
          !scope.section1val
        ) {
          const selectedCrsUnitclass = scope.crsUnitClass.filter(
            (crsUnitCls) =>
              crsUnitCls.PropertyTypeId ==
              scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.PropertyTypeID
          );
          const resultobjval = scope.UnitClass.filter(
            (selectedUnitCls) =>
              selectedUnitCls.OTAPropertyType.trim() ==
                selectedCrsUnitclass[0].ListType &&
              selectedUnitCls.PropertyId == scope.unitData.PropertyId
          );
          scope.selectedUnitClassObj = resultobjval[0];
          console.log("resultobjval", resultobjval[0]);
        }
      }
      if (!scope.section7val) {
        let AmenityList = scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Amenities && scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Amenities.Amenity && scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Amenities.Amenity.hasOwnProperty("0") ? Object.values(scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Amenities.Amenity) : scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Amenities && scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Amenities.Amenity ? [scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Amenities.Amenity] : []
        let aminitiesList = [];
        for (let Amenity of AmenityList) {
          if (
            Amenity._ != 61 &&
            Amenity._ != "61" &&
            Amenity._ != 52 &&
            Amenity._ != "52"
          ) {
            aminitiesList.push(Amenity._);
          }
        }
        let selecteAmi = [];
        for (let ami of scope.crsAmenities) {
          for (let crsami of aminitiesList) {
            if (
              crsami == ami.CrsAmenityId &&
              ami.PropertyId == scope.unitData.PropertyId
            ) {
              selecteAmi.push(ami.AmenityId);
            }
          }
        }

        console.log("selecteAmi == ", selecteAmi);
        if (Array.isArray(scope.AminitiesData)) {
          for (let amii of scope.AminitiesData) {
            for (let crsamii of selecteAmi) {
              if (crsamii == amii.ListId) {
                amii.IsChecked = 1;
              }
            }
          }
        }
        // scope.AminitiesData = AminitiesObj
      }
      // else {
      //   scope.selectedUnitClassObj.UnitClassId = scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.PropertyTypeID
      // }
    },
    // save section

    getUnitDetailById: function () {
      let scope = this;
      let property_temp_URL = null;
      let UnitURLId = null;
      let PropertyURLId = null;
      console.log("In view unit detail" + this.$route.params.propertyId);
      console.log("In view unit detail" + this.$route.query.crsPropertyId);
      property_temp_URL = this.$route.params.unitId;
      if (property_temp_URL < 0) {
        UnitURLId = -1;
        PropertyURLId = property_temp_URL.replace("-", "");
        console.log("In if loop" + UnitURLId + PropertyURLId);
        this.unitData.PropertyId = PropertyURLId;
        scope.isDisabled = true;
      } else {
        UnitURLId = property_temp_URL.replace("+", "");
        PropertyURLId = null;
        console.log("In else loop" + UnitURLId + PropertyURLId);
        scope.isDisabled = true;
      }

      console.log(" final value " + "urlid" + UnitURLId);
      console.log(" final value " + "propertyid" + PropertyURLId);
      
      this.$store.dispatch("dataRequestHandler", {
        key: "GetUnitDetailById",
        params: {
          ModuleAction: "GetUnitDetailById",
          UnitId: UnitURLId,
          PropertyId: scope.$route.params.propertyId,
        },
        callback: function (err, response) {
          console.log("GetUnitDetailById =>", response);
          if (response) {
            console.log("vm.$route.params.unitId", scope.$route.params.unitId);
            if (scope.$route.query.crsPropertyId) {
              scope.crsPropertyId = scope.$route.query.crsPropertyId;
              console.log("scope.crsPropertyId == ", scope.crsPropertyId);
            }
            if (response.UnitDataObj && response.UnitDataObj[0].StatusId != 1) {
              scope.showIntegrationScreen = false;
            } else if (response.UnitDataObj && response.UnitDataObj[0].StatusId == 1) {
              scope.showIntegrationScreen = true;
            }

            scope.IsRatesRestrictions = true;
            
            scope.statusList = response.StatusObj;
            console.log(" scope.statusList", response.StatusObj);
            
            scope.UnitClass = response.UnitClassObj;
            console.log(" scope.UnitClass", response.UnitClassObj);
            
            scope.unitTypeList = response.unitTypeList;
            scope.unitData = response.UnitDataObj[0];
            scope.crsUnitClass = response.crsUnitClass;
            scope.actualCrsAmenities = response.crsAmenities;
            scope.unitData.Description = scope.unitData.Description ? scope.unitData.Description.replace(/<br>/g, "\n") : scope.unitData.Description;
            scope.actualUnitClassList = JSON.parse(JSON.stringify(response.UnitClassObj));

            if (scope.unitData.PropertyId && scope.unitData.PropertyId != -1 && scope.unitData.PropertyId != -99) {
              let selectedPropertyUnitclass = scope.actualUnitClassList.filter((unitcls) => unitcls.PropertyId == scope.unitData.PropertyId);
              scope.UnitClass.splice(0, scope.UnitClass.length, ...selectedPropertyUnitclass);
            }
            console.log("scope.actualUnitClassList grt by id = ", scope.actualUnitClassList);

            scope.integrationChannels = response.integrationChannels[0];

            scope.RatesRestrictions_UnitType = response.UnitDataObj[0].RatesRestrictions_UnitType;
            scope.unitSets = response.unitSets;
            scope.selectedComponents = response.components;
            
            scope.filteredUnits.splice(0, scope.filteredUnits.length, ...response.components);
            if (scope.unitData.IsPercent == null || scope.unitData.IsPercent == false) {
              scope.unitData.IsPercent = 0;
            } else if (scope.unitData.IsPercent == true) {
              scope.unitData.IsPercent = 1;
            }
            scope.unitData.StartSaleDate = scope.unitData.StartSaleDate ? moment.utc(scope.unitData.StartSaleDate).format("DD MMM YYYY") : null;
            scope.unitData.EndSaleDate = scope.unitData.EndSaleDate ? moment.utc(scope.unitData.EndSaleDate).format("DD MMM YYYY") : null;
            scope.commissionPercent = scope.unitData.IsPercent;
            scope.CommissionAmount = scope.unitData.CommissionAmount;
            scope.editDefault = scope.unitData.UseDefault == 1 ? true : false;
            console.log("response in imageArr", response.ImgUrls);
            
            scope.commissionPercentColor = null;
            scope.Unit_Status = response.UnitDataObj[0].StatusId === 1 || response.UnitDataObj[0].StatusId === null || response.UnitDataObj[0] === undefined || response.UnitDataObj[0] === "" ? { StatusId: "1", StatusName: "Active" } : { StatusId: response.UnitDataObj[0].StatusId, StatusName: response.UnitDataObj[0].StatusName };
            console.log(" scope.unitData", response.UnitDataObj);
            scope.AminitiesData = response.AminitiesObj;
            console.log(" scope.Aminity", scope.AminitiesData);

            if (scope.$route.params.unitId !== "-99") {
              let selectedUnitclass = scope.UnitClass.filter((unitcls) => unitcls.UnitClassId == response.UnitDataObj[0].UnitClassId);
              scope.selectedUnitClassObj = selectedUnitclass[0];
              scope.status.StatusId = response.UnitDataObj[0].StatusId;
              scope.status.StatusName = response.UnitDataObj[0].StatusName;
              scope.unitID = response.UnitDataObj[0].UnitId;

              scope.selectedUnitTypeObj.UnitTypeId = response.UnitDataObj[0].UnitTypeId;
              scope.selectedUnitTypeObj.UnitTypeName = response.UnitDataObj[0].UnitTypeName;
              scope.selectedUnitTypeObj.UnitTypeNickname = response.UnitDataObj[0].UnitTypeNickname;
              scope.selectedUnitTypeObj.StatusId = response.UnitDataObj[0].UnitTypeStatusId;
              scope.selectedUnitTypeObj.propertyNickName = response.UnitDataObj[0].propertyNickName;

              scope.previousUnitTypeObj = scope.selectedUnitTypeObj;
              console.log("in unit", scope.selectedUnitClassObj);
              console.log("in unit", scope.status);
              scope.getRentalUnitedClients(scope.unitData.UnitId);
            }
            scope.Get_PaymentAccount_Details();
            
            scope.ruPropertyObj = scope.$store.getters.getpullRUSpecProp;
            scope.selectedRuClientAccountList = scope.$store.getters.getpullRUSpecProp ? scope.$store.getters.getpullRUSpecProp.rentalUnitedClient : [];
            if (scope.ruPropertyObj && Object.keys(scope.ruPropertyObj).length > 0) {
              scope.unitData.unitSetId = scope.unitSets[0].UnitSetId;
              scope.crsOwnerId = scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.OwnerID;
              scope.selectedRuClientAccountList = scope.ruPropertyObj.rentalUnitedClient;
              if (!scope.section1val) {
                scope.unitData.UnitName = scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Name;
                scope.unitData.SpaceValue = scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Space;
                scope.unitData.FloorValue = scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Floor;
              }
              let AmenityList = scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Amenities && scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Amenities.Amenity && scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Amenities.Amenity.hasOwnProperty("0") ? Object.values(scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Amenities.Amenity) : scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Amenities && scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Amenities.Amenity ? [scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Amenities.Amenity] : []
              if (!scope.section2val) {
                if (scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Images && scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Images.Image) {
                  let imagesArr = Object.values(scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Images.Image);
                  for (let img of imagesArr) {
                    console.log(img._);
                  }
                }
                scope.unitData.Description = scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.Descriptions.Description.Text;
              }

              if (!scope.section3val) {
                let taxesVal = scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.AdditionalFees && scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.AdditionalFees.AdditionalFee && !scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.AdditionalFees.AdditionalFee.hasOwnProperty("0") ? scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.AdditionalFees.AdditionalFee : null
                    let taxs = scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.AdditionalFees && scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.AdditionalFees.AdditionalFee && scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.AdditionalFees.AdditionalFee.hasOwnProperty("0") ? Object.values(scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.AdditionalFees.AdditionalFee) : taxesVal ? [taxesVal] : []
                for (let tax of taxs) {
                  if ((tax.$ && (tax.$.Name == "Cleaning Fees" || tax.$.Name == "Cleaning fee")) || (tax.Name == "Cleaning Fees" || tax.Name == "Cleaning fee")) {
                    scope.unitData.turnOverCleaningCharge = scope.$store.state.getFormattedAmount("", tax.Value);
                  }
                  if ((tax.$ && tax.$.Name == "Pet fee") || tax.Name == "Pet fee") {
                    scope.unitData.PetFee = scope.$store.state.getFormattedAmount("", tax.Value);
                  }
                }
                let CompositionRooms = Object.values(scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.CompositionRoomsAmenities.CompositionRoomAmenities);
                let rooms = [];
                for (let room of CompositionRooms) {
                  rooms.push(room.$.CompositionRoomID);
                  console.log(" room.$.CompositionRoomID", room.$.CompositionRoomID);
                }
                const elementCounts = {};

                rooms.forEach((element) => {
                  elementCounts[element] = (elementCounts[element] || 0) + 1;
                });
                console.log(elementCounts);
                scope.unitData.BedRooms = elementCounts[257];
                scope.unitData.NoOfBathrooms = elementCounts[81];
                for (let Amenity of AmenityList) {
                  if (Amenity._ == 61 || Amenity._ == "61") {
                    scope.unitData.NoOfBeds = Amenity.$.Count;
                  }
                }
              }

              if (!scope.section4val) {
                scope.unitData.MaxPersons = scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.CanSleepMax;
              }

              if (!scope.section5val) {
                scope.unitData.MaxPersons_Weekday = scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.StandardGuests;
              }
              if (!scope.section6val) {
                scope.unitData.MaxPersons_Weekend = scope.ruPropertyObj.Pull_ListSpecProp_RS.Property.StandardGuests;
              }
              if (!scope.section7val) {
                let aminitiesList = [];
                for (let Amenity of AmenityList) {
                  if (Amenity._ != 61 && Amenity._ != "61" && Amenity._ != 52 && Amenity._ != "52") {
                    aminitiesList.push(Amenity._);
                  }
                }
                let selecteAmi = [];
                for (let ami of scope.actualCrsAmenities) {
                  for (let crsami of aminitiesList) {
                    if (crsami == ami.CrsAmenityId && ami.PropertyId == scope.unitData.PropertyId) {
                      selecteAmi.push(ami.AmenityId);
                    }
                  }
                }
                console.log("selecteAmi == ", selecteAmi);

                console.log("selecteAmi == ", selecteAmi);
                console.log("AminitiesData == ", scope.AminitiesData);
                if (scope.AminitiesData && scope.AminitiesData.length > 0) {
                  for (let amii of scope.AminitiesData) {
                    for (let crsamii of selecteAmi) {
                      if (crsamii == amii.ListId) {
                        amii.IsChecked = 1;
                      }
                    }
                  }
                }
              }
            }
          } else {
            console.log(err);
          }
        },
      });
    },

    getImages: function () {
      let scope = this;
      let property_temp_URL = null;
      let UnitURLId = null;
      let PropertyURLId = null;
      console.log("In view unit detail" + this.$route.params.propertyId);
      property_temp_URL = this.$route.params.unitId;
      if (property_temp_URL < 0) {
        UnitURLId = -1;
        PropertyURLId = property_temp_URL.replace("-", "");
        console.log("In if loop" + UnitURLId + PropertyURLId);
        this.unitData.PropertyId = PropertyURLId;
        scope.isDisabled = true;
      } else {
        UnitURLId = property_temp_URL.replace("+", "");
        PropertyURLId = null;
        console.log("In else loop" + UnitURLId + PropertyURLId);
        scope.isDisabled = true;
      }

      this.$store.dispatch("dataRequestHandler", {
        key: "GetImages",
        params: {
          ModuleAction: "GetImages",
          UnitId: UnitURLId,
          PropertyId: scope.$route.params.propertyId,
          BE_Id: null,
        },
        callback: function (err, response) {
          if (response) {
            console.log("response of get Images", response);
            // if (response.ImgUrls && response.ImgUrls !== null) {
            //   scope.imageArr = response.ImgUrls;s

            // }
            if (response.recordsets[0] && response.recordsets[0] !== null) {
              scope.imageArr = response.recordsets[0];
            } else if (response.recordsets === null) {
              scope.imageArr = [];
            }
          } else {
            console.log(err);
          }
        },
      });
    },

    displaySection: function (name) {
      let vm = this;
      if (name === "UnitInfo1") {
        this.isBgColor1 = true;
        this.isBgColor3 = false;
        this.isBgColor2 = false;
        this.isBgColor4 = false;
        this.isBgColor5 = false;
        this.isBgColor6 = false;
        this.isBgColor7 = false;
        this.isBgColor8 = false;
        this.isBgColor9 = false;
        this.isBgColor10 = false;
        this.isBgColor11 = false;
        vm.hideFilterByType();
      }
      if (name === "UnitInfo2") {
        this.isBgColor2 = false;
        this.isBgColor1 = false;
        this.isBgColor3 = false;
        this.isBgColor4 = false;
        this.isBgColor5 = false;
        this.isBgColor6 = false;
        this.isBgColor7 = true;
        this.isBgColor8 = false;
        this.isBgColor9 = false;
        this.isBgColor10 = false;
        this.isBgColor11 = false;
        vm.hideFilterByType();
      }
      if (name === "UnitInfo3") {
        this.isBgColor3 = false;
        this.isBgColor2 = true;
        this.isBgColor1 = false;
        this.isBgColor4 = false;
        this.isBgColor5 = false;
        this.isBgColor6 = false;
        this.isBgColor7 = false;
        this.isBgColor8 = false;
        this.isBgColor9 = false;
        this.isBgColor10 = false;
        this.isBgColor11 = false;
        vm.hideFilterByType();
      }
      if (name === "UnitInfo4") {
        this.isBgColor1 = false;
        this.isBgColor3 = true;
        this.isBgColor2 = false;
        this.isBgColor4 = false;
        this.isBgColor5 = false;
        this.isBgColor6 = false;
        this.isBgColor7 = false;
        this.isBgColor8 = false;
        this.isBgColor9 = false;
        this.isBgColor10 = false;
        this.isBgColor11 = false;
        vm.hideFilterByType();
      }
      if (name === "UnitInfo5") {
        this.isBgColor1 = false;
        this.isBgColor3 = false;
        this.isBgColor2 = false;
        this.isBgColor4 = true;
        this.isBgColor5 = false;
        this.isBgColor6 = false;
        this.isBgColor7 = false;
        this.isBgColor8 = false;
        this.isBgColor9 = false;
        this.isBgColor10 = false;
        this.isBgColor11 = false;
        vm.hideFilterByType();
      }
      if (name === "UnitInfo6") {
        this.isBgColor1 = false;
        this.isBgColor3 = false;
        this.isBgColor2 = false;
        this.isBgColor4 = false;
        this.isBgColor5 = true;
        this.isBgColor6 = false;
        this.isBgColor7 = false;
        this.isBgColor8 = false;
        this.isBgColor9 = false;
        this.isBgColor10 = false;
        this.isBgColor11 = false;
        vm.hideFilterByType();
      }

      // if (name === "UnitInfo7") {
      //   this.isBgColor1 = false;
      //   this.isBgColor3 = false;
      //   this.isBgColor2 = false;
      //   this.isBgColor4 = false;
      //   this.isBgColor5 = false;
      //   this.isBgColor6 = true;
      //   this.isBgColor7 = false;
      //   this.isBgColor8 = false;
      //   this.isBgColor9 = false;
      // }
      if (name === "UnitInfo7") {
        this.isBgColor1 = false;
        this.isBgColor3 = false;
        this.isBgColor2 = false;
        this.isBgColor4 = false;
        this.isBgColor5 = false;
        this.isBgColor6 = true;
        this.isBgColor7 = false;
        this.isBgColor8 = false;
        this.isBgColor9 = false;
        this.isBgColor10 = false;
        this.isBgColor11 = false;
        vm.hideFilterByType();
      }
      if (name === "syncToRU") {
        this.isBgColor1 = false;
        this.isBgColor3 = false;
        this.isBgColor2 = false;
        this.isBgColor4 = false;
        this.isBgColor5 = false;
        this.isBgColor6 = false;
        this.isBgColor7 = false;
        this.isBgColor8 = true;
        this.isBgColor9 = false;
        this.isBgColor10 = false;
        this.isBgColor11 = false;
        vm.hideFilterByType();
      }
      if (name === "paymentSetup") {
        this.isBgColor1 = false;
        this.isBgColor3 = false;
        this.isBgColor2 = false;
        this.isBgColor4 = false;
        this.isBgColor5 = false;
        this.isBgColor6 = false;
        this.isBgColor7 = false;
        this.isBgColor8 = false;
        this.isBgColor9 = true;
        this.isBgColor10 = false;
        this.isBgColor11 = false;
        vm.hideFilterByType();
      }
      if (name === "components") {
        this.isBgColor1 = false;
        this.isBgColor3 = false;
        this.isBgColor2 = false;
        this.isBgColor4 = false;
        this.isBgColor5 = false;
        this.isBgColor6 = false;
        this.isBgColor7 = false;
        this.isBgColor8 = false;
        this.isBgColor9 = false;
        this.isBgColor10 = true;
        this.isBgColor11 = false;
      }
      if (name === "CustomFields") {
        this.isBgColor1 = false;
        this.isBgColor3 = false;
        this.isBgColor2 = false;
        this.isBgColor4 = false;
        this.isBgColor5 = false;
        this.isBgColor6 = false;
        this.isBgColor7 = false;
        this.isBgColor8 = false;
        this.isBgColor9 = false;
        this.isBgColor10 = false;
        this.isBgColor11 = true;
        vm.hideFilterByType();
      }

      this.displaySectionValue = name;
      // if ((name === "UnitInfo1")) {
      //   this.displaySectionValue = name;
      // } else if ((name !== "UnitInfo1") && (this.unitData.UnitName === "" || this.unitData.NickName === "" || this.unitData.UnitClassId === "" || this.unitData.PropertyId === "")) {
      //   this.displaySectionValue = null;
      //   this.$store.dispatch("toastr", {
      //     type: "warning",
      //     message: "Please enter UnitInfo1 Info !"
      //   });
      // }
      // if ((name === "UnitInfo2") && (this.unitData.UnitName !== "" && this.unitData.NickName !== "" && this.unitData.UnitClassId !== "" && this.unitData.PropertyId !== "")) {
      //   this.displaySectionValue = name;
      // } else if ((name !== "UnitInfo1") && (name !== "UnitInfo2") && (this.unitData.UnitName !== "" && this.unitData.NickName !== "" && this.unitData.UnitClassId !== "" && this.unitData.PropertyId !== "") && (this.unitData.UnitClassId === "" || this.unitData.UnitRank === "" || this.unitData.StatusId === "" || this.unitData.UnitNumber === "")) {
      //   this.displaySectionValue = null;
      //   this.$store.dispatch("toastr", {
      //     type: "warning",
      //     message: "Please enter UnitInfo2 Info !"
      //   });
      // }
      // if ((name === "UnitInfo3") && (this.unitData.UnitName !== "" && this.unitData.NickName !== "" && this.unitData.UnitClassId !== "" && this.unitData.PropertyId !== "") && (this.unitData.UnitClassId !== "" && this.unitData.UnitRank !== "" && this.unitData.StatusId !== "" && this.unitData.UnitNumber !== "")) {
      //   this.displaySectionValue = name;
      // }
    },
    deleteUnitSyncDetails(rentalUnitedClient) {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "deleteUnitSyncDetails",
        params: {
          UnitId: vm.unitID,
          fromMapping: 1,
          rentalUnitedClient: rentalUnitedClient,
          crsPropertyId: vm.unitData.CrsPropertyId,
        },
        callback: function (error, response) {
          console.log("deleteUnitSyncDetails response", response);
          if (error) {
            vm.$store.dispatch("toastr", {
              type: "error",
              message: "Unable to InActivate",
              header: "Error!",
            });
            return;
          }
          if (
            response[0] &&
            response[0].length > 0 &&
            response[0][0].ErrorMessage
          ) {
            vm.$store.dispatch("toastr", {
              type: "error",
              message: "Unable to InActivate",
              header: "Error!",
            });
          } else {
            vm.$store.dispatch("toastr", {
              type: "success",
              message: "InActivated Successfully",
              header: "Success!",
            });
            vm.integrationChannels.IsUnitMapped = false;
            vm.loadUnitDetails(rentalUnitedClient);
          }
        },
      });
    },
    syncUnitToRU(unitData, rentalUnitedClient) {
      let vm = this;
      let selectedRU = vm.ruClientAccountList.filter(
        (ruaccount) => ruaccount.IsDefault == true
      );
      rentalUnitedClient = rentalUnitedClient
        ? rentalUnitedClient
        : selectedRU[0];
      if (
        unitData == "Property Sync" &&
        rentalUnitedClient &&
        typeof rentalUnitedClient == "object"
      ) {
        if (
          vm.unitConnectedRuAccount.length > 0 &&
          rentalUnitedClient.UserName !=
            vm.unitConnectedRuAccount[0].UserName &&
          rentalUnitedClient.IntegrationId == 1
        ) {
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "warning!",
            message:
              "Can not push data to ru due to unit is mapped with other RU account",
          });
          return;
        }
      }
      vm.$store.dispatch("dataRequestHandler", {
        key: "syncUnitToRU",
        params: {
          UnitId: vm.unitID,
          // CrsPropertyId: vm.crsPropertyId,
          MessageType: unitData,
          CrsId: rentalUnitedClient.CrsId,//vm.unitData.IsHostMode ? 2 : 3,
          rentalUnitedClient: rentalUnitedClient,
          PropertyId: vm.unitData.PropertyId,
        },
        callback: function (error, response) {
          console.log("unit1 response", response);
          if (unitData == "Property Sync") {
            if (response && response.PropertyId != -1) {
              // vm.crsPropertyId = response.PropertyId;
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Unit sync successfull",
              });
              vm.integrationChannels.IsUnitMapped = true;
              vm.getUnitDetailById();
              if (
                rentalUnitedClient &&
                typeof rentalUnitedClient == "object" &&
                rentalUnitedClient.CrsId == 2
              ) {
                vm.$refs.RUIntegration.pullPropertyList(rentalUnitedClient);
                vm.$refs.RUIntegration.getRentalUnitedClients();
              }
              vm.getRentalUnitedClients(vm.unitData.UnitId);
            } else {
              vm.$store.dispatch("toastr", {
                type: "warning",
                header: "warning!",
                message: "Unit sync failed ",
              });
            }
          }
          if (unitData == "Rates") {
            if (response && response.message == "Success") {
              // vm.crsPropertyId = response.PropertyId;
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Rates sync successfull",
              });
            } else if (response && response.message) {
              vm.$store.dispatch("toastr", {
                type: "warning",
                header: "warning!",
                message: "Rates sync failed " + response.message,
              });
            }
          }
          if (unitData == "Inventory") {
            if (response && response.message == "Success") {
              // vm.crsPropertyId = response.PropertyId;
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Inventory sync successfull",
              });
            } else if (response && response.message) {
              vm.$store.dispatch("toastr", {
                type: "warning",
                header: "warning!",
                message: "Inventory sync failed " + response.message,
              });
            }
          }
          if (unitData == "Restrictions") {
            if (response && response.message == "Success") {
              // vm.crsPropertyId = response.PropertyId;
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Restrictions sync successfull",
              });
            } else if (response && response.message) {
              vm.$store.dispatch("toastr", {
                type: "warning",
                header: "warning!",
                message: "Restrictions sync failed " + response.message,
              });
            }
          }
        },
      });
    },
    Get_PaymentAccount_Details() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "Get_PaymentAccount_Details",
        params: {
          ModuleAction: "Get_PaymentAccount_Details",
          propertyId: vm.unitData.PropertyId,
          unitId: vm.unitID,
          isClient: true,
          IsActive: vm.IsActive,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            console.log("response in Get_PaymentAccount_Details", response);
            vm.paymentAccountList.splice(
              0,
              vm.paymentAccountList.length,
              ...response[2]
            );
            vm.paymentAccountList = vm.paymentAccountList.filter(
              (data) => data.GatewayId === 1
            );
            vm.IsLive = response[3][0].IsLive;
          }
        },
      });
    },
    hideFilterByType() {
      this.showUnitsList = false;
      $("#unitSearchDropDown").hide();
    },
    showFilterByType() {
      var vm = this;
      setTimeout(function () {
        vm.showUnitsList = !this.showUnitsList;
        vm.selectedFilterColumn = "unit";
        vm.GetUnitListBySearchText();
        $("#unitSearchDropDown").show();
      }, 10);
    },
    addToFilter(Obj) {
      let vm = this;
      if (vm.selectedFilterColumn == "unit") {
        vm.filteredUnits.push(Obj);
        vm.filterSearchUnitText = null;
        var index = vm.unitList.indexOf(Obj);
        if (index > -1) {
          vm.unitList.splice(index, 1);
        }
        vm.GetUnitListBySearchText();
      }
    },
    GetUnitListBySearchText(searchText) {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetUnitListBySearchText",
        params: {
          searchText: searchText,
          PropertyId: vm.unitData.PropertyId,
          ClientId: vm.unitData.ClientId,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }
          if (response) {
            // console.log("response in GetUnitListBySearchText", response);
            vm.unitList.splice(0, vm.unitList.length, ...response.unitList);
          }
        },
      });
    },
    removeUnitFromFilter(unitObj) {
      let vm = this;
      var index = vm.filteredUnits.indexOf(unitObj);
      if (index > -1) {
        vm.filteredUnits.splice(index, 1);
      }
      vm.unitList.push(unitObj);
    },
    saveUnit_Components() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "SaveUnit_Components",
        params: {
          unitId: vm.unitData.UnitId,
          propertyId: vm.unitData.PropertyId,
          components: vm.filteredUnits,
        },
        callback: function (err, response) {
          if (err) {
            return;
          }

          if (response) {
            // vm.unitList.splice(
            //   0,
            //   vm.unitList.length,
            //   ...response.unitList
            // );

            if (
              response[0] &&
              response[0].length > 0 &&
              response[0][0].ErrorMessage
            ) {
              vm.$store.dispatch("toastr", {
                type: "error",
                message: "Error!",
                header: "Eroor while saving Unit Components",
              });
            } else {
              vm.$store.dispatch("toastr", {
                type: "success",
                message: "Unit Components saved successfully",
                header: "",
              });
            }
          }
        },
      });
    },
    getCustomFields() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetCustomFields",
        params: {
          CustomEntityID: 4,
        },
        callback: function (err, response) {
          if (response) {
            vm.customFieldsList = response.recordsets[0];
            console.log('GetCustomFields response', response);
          } else {
            console.log("GetCustomFields error",err);
          }
        }
      });
    },
    saveCustomFieldInstances() {
        let vm = this;
        vm.customFieldsList.forEach(currentField => {
          console.log('currentField', currentField);
          console.log('vm.$route.params.propertyId', vm.$route.params.propertyId);
          if(vm.$route.params.unitId != -99){
            vm.$store.dispatch("dataRequestHandler", {
              key: "SaveCustomFieldInstances",
              params: {
                CustomEntityID: currentField.CustomEntityID,
                FieldID: currentField.FieldID,
                FieldTypeID: currentField.FieldTypeID,
                FieldTypeName: currentField.FieldTypeName,
                FieldTypeValue: currentField.FieldTypeValue ? currentField.FieldTypeValue : "",
                CustomFieldName: currentField.CustomFieldName,
                PropertyID: vm.$route.params.propertyId ? vm.$route.params.propertyId : null,
                UnitTypeID: null,
                ListingID: vm.$route.params.unitId,
                Config: "",
              },
              callback: function (err, response) {
                if (response) {
                  console.log('SaveCustomFieldInstances response:', response);
                  // vm.getCustomFields();
                  // vm.getCustomFieldInstances();
                  vm.$store.dispatch("toastr", {
                    type: "success",
                    header: "Success",
                    message: "Custom Fields Value Saved Successfully",
                  });
                } else {
                  console.log("SaveCustomFieldInstances error", err);
                  vm.$store.dispatch("toastr", {
                    type: "error",
                    header: "Error",
                    message: "Error while Saving Custom Fields Value",
                  });
                }
              }
            });
          }else{
            vm.$store.dispatch("toastr", {
              type: "warning",
              header: "Warning",
              message: "Please Create Unit"
            });
          }
        });
    },
    getCustomFieldInstances() {
      let vm = this;
      vm.$store.dispatch("dataRequestHandler", {
        key: "GetCustomFieldInstances",
        params: {
          // ClientID: 5,
          PropertyID: vm.$route.params.propertyId ? vm.$route.params.propertyId : null,
          // UnitTypeId: vm.unitTypeData.UnitTypeId,
          ListingID: vm.$route.params.unitId,
          CustomEntityID: 4,
        },
        callback: function (err, response) {
          if (response) {
            console.log('GetCustomFieldInstances response', response);
            let customFieldInstances = response.recordsets[0];
            vm.customFieldsList.forEach(field => {
              let instance = customFieldInstances.find(instance => instance.FieldID === field.FieldID);
              field.FieldTypeValue = instance ? instance.FieldTypeValue : null;
            });
          } else {
            console.log("GetCustomFieldInstances error",err);
          }
        }
      });
    },
    isInputType(fieldType) {
      return ['Number', 'String'].includes(fieldType);
    },
    getInputType(fieldType) {
      let vm = this;
      switch (fieldType) {
        case 'Number':
          vm.customFieldPlaceHolder = 'Enter Numeric Value';
          return 'number';
        case 'String':
          vm.customFieldPlaceHolder = 'Enter Custom Field Value';
          return 'text';
        default:
          vm.customFieldPlaceHolder = 'Enter Custom Field Value';
          return 'text';
      }
    },
    parseLovJSON(value) {
      try {
          return JSON.parse(value);
      } catch {
          return [];
      }
    },
    parsedLovConfig(config) {
      return JSON.parse(config);
    },
    filteredListofValues(list) {
      let vm = this;
      const selectedValues = vm.parseLovJSON(list.FieldTypeValue) || [];
      const listOfValues = vm.parsedLovConfig(list.Config).ListOfValues || [];
      return listOfValues.filter(value => !selectedValues.includes(value.value) && (value.statusId !== -1 && value.statusId !== -2));
    },
    initializeShowLovList(fieldID) {
      if (typeof this.showLovList !== 'object') {
        this.showLovList = {};
      }
      if (!(fieldID in this.showLovList)) {
        this.$set(this.showLovList, fieldID, false);
      }
    },
    showLovListFnc(fieldID) {
      this.selectedLovDropdown = fieldID
      this.initializeShowLovList(fieldID);
      this.$set(this.showLovList, fieldID, !this.showLovList[fieldID]);
      setTimeout(() => {
        $("#Lovsdropdowns-" + fieldID).show();
      }, 10);
    },
    toggleDropdown(fieldID) {
      this.initializeShowLovList(fieldID);
      this.$set(this.showLovList, fieldID, !this.showLovList[fieldID]);
    },
    removeListOfValues(fieldID, index) {
      let vm = this;
      const list = vm.customFieldsList.find(field => field.FieldID === fieldID);
      if (list && Array.isArray(vm.parseLovJSON(list.FieldTypeValue))) {
          const parsedValue = vm.parseLovJSON(list.FieldTypeValue);
          parsedValue.splice(index, 1);
          list.FieldTypeValue = JSON.stringify(parsedValue) == '[]' ? '' : JSON.stringify(parsedValue);
      }
      vm.showLovListFnc(fieldID);
    },
    addListOfValues(fieldID, value) {
      let vm = this;
      const list = vm.customFieldsList.find(field => field.FieldID === fieldID);
      if (list) {
          let parsedValue = vm.parseLovJSON(list.FieldTypeValue);
          if (!Array.isArray(parsedValue)) {
              parsedValue = [];
          }
          parsedValue.push(value.value);
          list.FieldTypeValue = JSON.stringify(parsedValue);
      }
      vm.showLovListFnc(fieldID);
    },
    updateCustomFieldDate(key, dateObj, list) {
      const field = this.customFieldsList.find(field => field.FieldID === list.FieldID);
      if (field) {
        field.FieldTypeValue = dateObj ? dateObj.format("DD MMM YYYY") : null;
      } 
    },
    formatFieldTypeValue(value) {
      if (!value) {
          return '';
      }
      if (value.startsWith('["') && value.endsWith('"]')) {
          return value.slice(2, -2).split('","').join(',');
      }
      return value;
    }
  },

  computed: {
    formattedMessage() {
      return this.unitData.Description
        ? this.unitData.Description.replace(/\n/g, "<br>")
        : this.unitData.Description;
    },
    fncIsUnitSave() {
      let vm = this;
      if (vm.unitID === "-1" || vm.unitID === -1) {
        return vm.$store.state.userEntitlementList.hasOwnProperty("fncUnitSave")
          ? vm.$store.state.userEntitlementList.fncUnitSave
          : null;
      } else if (vm.unitID > 0) {
        return vm.$store.state.userEntitlementList.hasOwnProperty(
          "fncUnitUpdate"
        )
          ? vm.$store.state.userEntitlementList.fncUnitUpdate
          : null;
      }
    },
    unAssignedUnits() {
      // if (this.filteredUnits.length) {

      for (var i = this.unitList.length - 1; i >= 0; i--) {
        if (this.filteredUnits.length) {
          for (var j = 0; j < this.filteredUnits.length; j++) {
            if (
              this.unitList[i] &&
              (this.unitList[i].UnitId === this.filteredUnits[j].UnitId ||
                this.unitList[i].UnitsetId == 4)
            ) {
              this.unitList.splice(i, 1);
            }
          }
        } else if (this.unitList[i].UnitsetId == 4) {
          this.unitList.splice(i, 1);
        }
      }
      // }
      return this.unitList;
    },
  },
  watch: {
    // selectedUnitTypeObj(oldvalue, newvalue) {
    //   console.log("oldvalue + newvalue==>", oldvalue + newvalue);
    //   this.IsRatesRestrictions = false;
    // }

    selectedUnitTypeObj: {
      handler: function (oldobj, newobj) {
        if (oldobj.UnitTypeName != newobj.UnitTypeName) {
          console.log(
            "oldvalue========>",
            oldobj.UnitTypeName + newobj.UnitTypeName
          );
          this.IsRatesRestrictions = false;
        }
      },
      deep: true,
    },
    filterSearchUnitText(searchText) {
      this.GetUnitListBySearchText(searchText);
    },
    componentIntegrationId() {
      this.Get_PaymentAccount_Details();
    },
  },
  mounted() {
    let vm = this;
    vm.getPropertyMetaData();
    vm.getUnitDetailById();
    vm.getImages();
    vm.Get_ListOfIntegrations();
    $(document).click(function (e) {
      // console.log("clicked on doc");
      let classsName = "#" + vm.paymentAccountEdit;
      $(classsName).removeClass("show");
      vm.showUnitsList = false;
      $("#unitSearchDropDown").hide();
      $("#Lovsdropdowns-"+vm.selectedLovDropdown).hide();
      // $(".form-control.searchResultsUnits").hide();
    });
    vm.getCustomFields();
    vm.getCustomFieldInstances();
  },
};
</script>
<style scoped>
.container {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

h1 {
  color: #50d1c1;
}

.gallery {
  width: 80%;
  max-width: 980px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.pic {
  width: calc(50% - 30px);
  margin: 15px;
  cursor: pointer;
}

.pic:hover img {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0);
  transform: scale(1.01);
}

.btn:active {
  color: #ccc;
  background-color: #6ab5ae;
  border-color: #6ab5ae;
  outline: none;
}
.integrationCard_bg {
  cursor: default;
}
.disabled_customField_class {
  pointer-events: none;
  opacity: 0.5;
}
</style>
